import React, { useState } from "react";
import "./styles.scss";
import { useDispatch, useSelector } from "react-redux";
import { Button, FormHeader, InputBox, RadioButton } from "../../../components";
import { CheckValidity } from "../../../utils";
import { Store } from "react-notifications-component";
import {
  closeConnectDBModal,
  setDBTypeValue,
} from "../../dataWarehouse/redux/actions";
import {
  checkMongoDBConnection,
  checkMySQLConnection,
} from "../../dataWarehouse/services/dataWarehouse.service";

const Index = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [dbType, setDbType] = useState("mysql");
  const [formData, setFormData] = React.useState({
    host: {
      key: "host",
      label: "Host/IP",
      size: "lg",
      isShowRequired: true,
      elementConfig: {
        type: "text",
        placeholder: "Enter your database host or IP",
      },
      validation: {
        required: true,
      },
      touched: false,
      isValid: false,
      invalidReason: "",
      value: "",
      isRequired: true,
    },
    port: {
      key: "port",
      label: "Port (default 3306)",
      size: "lg",
      isShowRequired: true,
      elementConfig: {
        type: "text",
        placeholder: "Enter your database port",
      },
      validation: {
        required: true,
        number: true,
      },
      touched: false,
      isValid: false,
      isLoading: false,
      invalidReason: "",
      value: "",
      isRequired: true,
    },
    userName: {
      key: "userName",
      label: "Username",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "Enter your database username",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    password: {
      key: "password",
      label: "Password",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "Enter your database password",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    databaseName: {
      key: "databaseName",
      label: "Database Name",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "Enter your database name",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    uri: {
      key: "uri",
      label: "URI connection string",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "Enter your database URI connection string",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const { isOpenConnectDBModal, dbTypes } = useSelector(
    ({ warehouseReducer }) => warehouseReducer
  );

  const dispatch = useDispatch();

  const handleChange = async (event, inputIdentity) => {
    const updateContactForm = {
      ...formData,
    };

    updateContactForm[inputIdentity].value = event;

    let validityRes = await CheckValidity(
      inputIdentity,
      updateContactForm[inputIdentity].value,
      updateContactForm[inputIdentity].validation
    );

    if (validityRes) {
      updateContactForm[inputIdentity].isValid = validityRes.isValid;
      updateContactForm[inputIdentity].invalidReason = validityRes.reason;
      updateContactForm[inputIdentity].touched = true;
      // updateContactForm[inputIdentity] = updatedFormElement;
      let formIsValid = false;
      for (let inputIdentifier in updateContactForm) {
        formIsValid = updateContactForm[inputIdentifier].valid && formIsValid;
      }

      setFormData(updateContactForm);
    }
  };

  const clearAll = () => {
    const updateNewsForm = {
      ...formData,
    };
    for (let key in updateNewsForm) {
      updateNewsForm[key].value = "";
      updateNewsForm[key].isValid = false;
      updateNewsForm[key].touched = false;
    }
    setFormData(updateNewsForm);
  };

  const onClickCheckConnection = async () => {
    setIsLoading(true);

    const updateCategoryForm = {
      ...formData,
    };

    if (dbType === "mysql") {
      if (
        updateCategoryForm.host.value === "" ||
        updateCategoryForm.port.value === "" ||
        updateCategoryForm.userName.value === "" ||
        updateCategoryForm.password.value === "" ||
        updateCategoryForm.databaseName.value === ""
      ) {
        Store.addNotification({
          title: "Error!",
          message: "Please fill all the fields!",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });
        setIsLoading(false);
        return;
      }
    }
    if (dbType === "mongodb") {
      if (updateCategoryForm.uri.value === "") {
        Store.addNotification({
          title: "Error!",
          message: "Please fill the URI field!",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });
        setIsLoading(false);
        return;
      }
    }

    try {
      let response;
      if (dbType === "mysql") {
        response = await checkMySQLConnection({
          db_type: dbType,
          host: updateCategoryForm.host.value,
          port: updateCategoryForm.port.value,
          userName: updateCategoryForm.userName.value,
          password: updateCategoryForm.password.value,
          database: updateCategoryForm.databaseName.value,
        });
      } else if (dbType === "mongodb") {
        response = await checkMongoDBConnection({
          db_type: dbType,
          uri: updateCategoryForm.uri.value,
        });
      }
      console.log("response connection::", response);
      if (response?.data?.status) {
        Store.addNotification({
          title: "Success!",
          message: "Connection successful!",
          type: "success",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        const fileName = response?.data?.env_file?.env_file?.split("\\").pop();
        console.log("fileName::", fileName);
        let isExist = dbTypes.some((dbType) => dbType.value === fileName);
        if (!isExist) {
          dispatch(setDBTypeValue({ value: fileName, displayValue: dbType }));
        }
        dispatch(closeConnectDBModal());
        setIsLoading(false);
        clearAll();
      } else {
        setIsLoading(false);
        if (!response?.data?.status && response?.data?.env_file) {
          const fileName = response?.data?.env_file?.env_file
            ?.split("\\")
            .pop();
          console.log("fileName::", fileName);
          let isExist = dbTypes.some((dbType) => dbType.value === fileName);
          if (!isExist) {
            dispatch(setDBTypeValue({ value: fileName, displayValue: dbType }));
          }
          dispatch(closeConnectDBModal());
        }

        Store.addNotification({
          title: "Error!",
          message: response?.data?.message || "Connection failed!",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });
      }
    } catch (error) {
      Store.addNotification({
        title: "Error!",
        message: "Connection failed. Please check your credentials.",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
      setIsLoading(false);
    }
  };

  const updateContactForm = { ...formData };

  return (
    <>
      <div
        className={`common-modal-out-bg-wrapper ${
          isOpenConnectDBModal ? "open_me" : "close__me"
        }`}
      />
      <div
        className={`common-modal-base-wrapper modal-container d-flex flex-column db-connection-modal animate__animated  ${
          isOpenConnectDBModal ? "open_me animate__bounceIn" : "close__me"
        }`}
      >
        {/* <BgEffect /> */}
        <FormHeader
          data={{
            layerStyle: "mb-1",
            formHeader: "Setup new connection",
            size: "lg",
          }}
        />
        {/* <div className="common-modal-close">
          <ButtonIcon
            data={{ iconName: "cross", size: "sm" }}
            onClick={() => dispatch(closeConnectDBModal())}
          />
        </div> */}
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          <div className="d-flex flex-column justify-content-between">
            <div className={"mtw_txt-lbl d-flex flex-row"}>
              <label className={"txt-label"}>Choose your database type</label>
              {/* {GetIcon(data.lblIcon)} */}
            </div>
            <div className="d-flex flex-row" style={{ gap: "1rem" }}>
              <RadioButton
                data={{
                  name: "MySQL",
                  isActive: dbType === "mysql",
                }}
                onClick={() => {
                  setDbType("mysql");
                }}
              />
              <RadioButton
                data={{
                  name: "MongoDB",
                  isActive: dbType === "mongodb",
                }}
                onClick={() => {
                  setDbType("mongodb");
                }}
              />
            </div>
          </div>
          <div className="dcm__contact-form">
            {dbType === "mysql" && (
              <>
                <InputBox
                  data={updateContactForm.host}
                  onChange={async (e) => {
                    e.preventDefault();
                    await handleChange(
                      e.target.value,
                      updateContactForm.host.key
                    );
                  }}
                />
                <InputBox
                  data={updateContactForm.port}
                  onChange={async (e) => {
                    e.preventDefault();
                    await handleChange(
                      e.target.value,
                      updateContactForm.port.key
                    );
                  }}
                />
                <InputBox
                  data={updateContactForm.userName}
                  onChange={async (e) => {
                    e.preventDefault();
                    await handleChange(
                      e.target.value,
                      updateContactForm.userName.key
                    );
                  }}
                />
                <InputBox
                  data={updateContactForm.password}
                  onChange={async (e) => {
                    e.preventDefault();
                    await handleChange(
                      e.target.value,
                      updateContactForm.password.key
                    );
                  }}
                />
              </>
            )}
          </div>
          {dbType === "mysql" && (
            <div style={{ width: "100%" }}>
              <InputBox
                data={updateContactForm.databaseName}
                onChange={async (e) => {
                  e.preventDefault();
                  await handleChange(
                    e.target.value,
                    updateContactForm.databaseName.key
                  );
                }}
              />
            </div>
          )}
          {dbType === "mongodb" && (
            <InputBox
              data={updateContactForm.uri}
              onChange={async (e) => {
                e.preventDefault();
                await handleChange(e.target.value, updateContactForm.uri.key);
              }}
            />
          )}
          <div className="dcm__form-actions">
            <Button
              data={{
                mainLayerStyles: "mt-3",
                btnName: "CANCEL",
                buttonType: "secondary border",
                buttonSize: "sm",
                isLoading: false,
                disable: false,
              }}
              onClick={async (e) => {
                clearAll();
                e.preventDefault();
                dispatch(closeConnectDBModal());
              }}
            />
            <Button
              data={{
                mainLayerStyles: "mt-3",
                btnName: "TEST & CONNECT",
                buttonType:
                  dbType === "mysql"
                    ? updateContactForm.host.value === "" ||
                      updateContactForm.port.value === "" ||
                      updateContactForm.userName.value === "" ||
                      updateContactForm.password.value === "" ||
                      updateContactForm.databaseName.value === ""
                      ? "primary disabled"
                      : "primary"
                    : dbType === "mongodb"
                    ? updateContactForm.uri.value === ""
                      ? "primary disabled"
                      : "primary"
                    : "primary",
                buttonSize: "sm",
                isLoading: isLoading,
                disable:
                  dbType === "mysql"
                    ? updateContactForm.host.value === "" ||
                      updateContactForm.port.value === "" ||
                      updateContactForm.userName.value === "" ||
                      updateContactForm.password.value === "" ||
                      updateContactForm.databaseName.value === ""
                      ? true
                      : false
                    : dbType === "mongodb"
                    ? updateContactForm.uri.value === ""
                      ? true
                      : false
                    : false,
              }}
              onClick={async (e) => {
                e.preventDefault();
                await onClickCheckConnection();
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
